module.exports = __webpack_public_path__ + "media/images/icons/play_green-2364ea649ee2edbeab4e641c8bf95158.svg";